import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { Icons } from "atoms/constants/icons";
import { useSortable } from "@dnd-kit/sortable";
import Icon from "atoms/icons/icon";
import { IconPositions } from "atoms/constants/icon-positions";
import { DEFAULT_SORTABLE_DRAG_AND_DROP_SCOPE_NAME } from "organisms/sortable-drap-and-drop/shared-sortable-drag-and-drop-list";
import { ScopedDragAndDropData } from "utilities/contexts/shared-drag-and-drop/scoped-drag-and-drop-data";
import { IconSizes } from "atoms/constants/icon-sizes";

export enum DragButtonStyles {
    Default = "-default",
    Light = "-light",
}
export interface SortableDragAndDropItemProps {
    allowIconOnlyDrag?: boolean;
    children: JSX.Element;
    dragAndDropScopeName?: string;
    draggableData?: object;
    enabled?: boolean;
    iconPosition?: IconPositions;
    id: string | number;
    dragButtonStyle?: DragButtonStyles;
    size?: IconSizes;
    iconOnHoverOnly?: boolean;
}

const BASE_CSS_CLASS = "c-sortable-drag-and-drop-item";

const SortableDragAndDropItem = (props: SortableDragAndDropItemProps) => {
    const {
        allowIconOnlyDrag = false,
        children,
        dragAndDropScopeName = DEFAULT_SORTABLE_DRAG_AND_DROP_SCOPE_NAME,
        enabled = true,
        iconPosition = IconPositions.Left,
        id,
        draggableData = {},
        dragButtonStyle = DragButtonStyles.Default,
        size,
        iconOnHoverOnly = false,
    } = props;

    const scopedDraggableData: ScopedDragAndDropData = {
        scope: dragAndDropScopeName,
    };

    const { listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({
            data: {
                ...draggableData,
                ...scopedDraggableData,
            },
            disabled: !enabled,
            id,
        });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 1 : "auto",
    };

    return (
        <div
            className={`${BASE_CSS_CLASS} ${iconOnHoverOnly ? "-iconOnHoverOnly" : ""} ${allowIconOnlyDrag ? "-iconDragOnly" : ""}`}
            ref={setNodeRef}
            style={style}
            {...(!allowIconOnlyDrag && listeners)}>
            {enabled && (
                <button
                    className={`${BASE_CSS_CLASS}__button  ${iconPosition} ${dragButtonStyle}`}
                    {...(allowIconOnlyDrag && listeners)}>
                    <Icon
                        cssClassName={`${BASE_CSS_CLASS}__icon`}
                        type={Icons.DragAndDrop}
                        size={size}
                    />
                </button>
            )}
            <div className={`${BASE_CSS_CLASS}__children`}> {children}</div>
        </div>
    );
};

export default SortableDragAndDropItem;
